import React, { useMemo} from 'react';

const PartnerPagination = ({ totalElements, selectedItemsPerPage, onItemsPerPageChange }) => {
    const handleOptionChange = (option) => {
        onItemsPerPageChange(option);
    };
    const paginationOptions = useMemo(() => {
        const options = [];
        const maxOption = Math.ceil(totalElements / 10) * 10;
        for (let i = 10; i <= maxOption; i += 10) {
            options.push(i);
        }
        return options;
    }, [totalElements]);
    return (
        <div className="hs-dropdown relative inline-flex items-center [--placement:bottom-right] ml-9">
            <span className="mr-3">Show</span>
            <button
                id="hs-dropdown"
                type="button"
                className="hs-dropdown-toggle py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-600 transition-all text-sm"
            >
                {selectedItemsPerPage}
                <svg
                    className="hs-dropdown-open:rotate-180 w-2.5 h-2.5 text-gray-600"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2 5L8.16086 10.6869C8.35239 10.8637 8.64761 10.8637 8.83914 10.6869L15 5"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                </svg>
            </button>

            <div className="hs-dropdown-menu w-20 transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden z-10 bg-white shadow-md rounded-lg p-2 dark:bg-gray-800 dark:border dark:border-gray-700 dark:divide-gray-700">
                {paginationOptions.map((option) => (
                    <a
                        key={option}
                        className={`flex hover:no-underline hover:text-[#222] items-center gap-x-3.5 py-2 px-3 rounded-md text-sm text-gray-800 hover:bg-gray-100 focus:ring-2 focus:ring-blue-500 ${
                            option === selectedItemsPerPage  ? 'font-bold' : ''
                        } dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-300`}
                        onClick={() => handleOptionChange(option)}
                    >
                        {option}
                    </a>
                ))}
            </div>
        </div>
    );
};

export default PartnerPagination;
